<template>
  <div class="c-app flex-row align-items-center">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="8">
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody style="display: grid; place-content: center;">
								<CCol col="12">
									<h1 style="text-align: center;">Vida Anáhuac </h1>
                  <p style="text-align: center;" class="text-muted">Iniciar sesión en su cuenta</p>
										<CButton block color="light" shape="pill" @click="login" :disabled="enviandoDatos ||authWrapper.isLoading" class="mt10">
											<img src="img/ms.png" class="c-sidebar-brand-full" alt="Cuenta Microsoft" height="15" />
											{{enviandoDatos || authWrapper.isLoading ? 'Validando...' : 'Iniciar con Cuenta Microsoft'}}
										</CButton>
								</CCol>
              </CCardBody>
            </CCard>
            <CCard
              color="warning"
              text-color="white"
              class="text-center py-5 d-md-down-none"
              body-wrapper
            >
              <CCardBody>
                <img src="img/logo.png" class="c-sidebar-brand-full" alt="Red de Universidades Anáhuac" height="200" />
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
import { required, email, minLength } from "vuelidate/lib/validators";
import cryptoJs from '../../services/CryptoJsService';

export default {
  	name: 'Login',
  	data () {
    	return {
			router: this.$router,
			authWrapper: this.$AuthService,
			textButton: 'Iniciar Sesión',  
      		oAuth: {
				"grant_type": 'password',
				"client_id": process.env.VUE_APP_API_CLIENT_ID,
				"client_secret": process.env.VUE_APP_API_CLIENT_SECRET
			},
      enviandoDatos: false,
			advertencia: false,
			msgAdvertencia: '',
    	}
  	},
  	validations: {
    	oAuth: {
      		username: { required, email },
      		password: { required, minLength: minLength(8) }
    	}    
  	},
  	created() {
    },
  	computed: {
    	user: function() {
      		return this.$AuthService.getUser()
    	}
  	},
  	methods: {
    	validar(ev) {
      		if (typeof ev != 'undefined' && ev.$dirty) {
        		return !ev.$error;
      		}
      		return
    	},
    	claseValida(ev) {
      		if (typeof ev != 'undefined' && ev.$dirty) {
        		return !ev.required ? ' is-invalid' : ' is-valid';
      		}
      		return '';
    	},
    	loginAPI() {
			this.$v.oAuth.$touch();
      		if(this.$v.oAuth.$error) return;
			this.enviandoDatos = true;
			this.textButton = 'Validando ...';

			this.$axios.post(process.env.VUE_APP_API_URL + 'oauth/token', this.oAuth, {
				headers: { 'Content-Type': 'application/json' }
			}).then(response => {
				this.textButton = 'Login exitoso ...';
				const tokenData = response.data;
				const headers = {
					headers: { 'Authorization': tokenData.token_type + ' ' + tokenData.access_token }
				};
				this.$axios.get(process.env.VUE_APP_API_URL + 'api/usuario/por-correo/' + this.oAuth.username, headers)
				.then(r => {
					const oUsuario = r.data.data;
					this.$axios.get(process.env.VUE_APP_API_URL + 'api/menu-usuario/' + oUsuario.idPerfil, headers)
					.then(r2 => {
						tokenData.time_get_token = Date.now();
						tokenData.user = oUsuario;
						tokenData.menu = r2.data.data;
						localStorage.setItem( 'tokenData', cryptoJs.encrypt(JSON.stringify(tokenData)) );
						//this.$router.push('/inicio');
						if (oUsuario.perfil == 'Alumno') {
							window.location.href = "/eventos-anahuac";
						} else {
							window.location.href = "/inicio";
						}
					}).catch(error => { console.log(error); console.log(error.response); })
				}).catch(error => { console.log(error); console.log(error.response); })
			}).catch(error => {
				this.advertencia = true;
                this.textButton = 'Iniciar Sesión';
				this.msgAdvertencia = 'Usuario o contraseña incorrectos';
				this.enviandoDatos = false;
				setTimeout(() => { 
                    this.msgAdvertencia = '';
                    this.advertencia = false;
                }, 5000);
                this.enviandoDatos = false;       
			})
		},
    	login() {
				this.enviandoDatos = true;
				this.textButton = 'Validando ...';
      	this.$AuthService.login();
    	}
  	}
}
</script>
